import "./es.object.assign-7e79fd7b.js";
import { useRef as R, useEffect as m, useState as y, useCallback as v } from "react";
import { useInterval as A } from "./useInterval.js";
import { useIsFirstRender as G } from "./useIsFirstRender.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./web.set-timeout-72b6430f.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
function Q(i) {
  var p = i.startPage, n = p === void 0 ? 1 : p, N = i.activePage, o = N === void 0 ? n : N, c = i.totalPage, g = i.cycleNavigation, T = i.autoNavigate, x = i.interval, I = x === void 0 ? 3e3 : x, l = i.onPageChange, f = i.onNextPage, d = i.onPreviousPage, h = G(), u = R({
    onPageChange: l,
    onNextPage: f,
    onPreviousPage: d
  });
  m(function() {
    u.current = {
      onPageChange: l,
      onNextPage: f,
      onPreviousPage: d
    };
  }, [l, f, d]);
  var e = R({
    isFirstRender: h,
    totalPage: c,
    startPage: n,
    lastPage: o,
    currentPage: o,
    previousPage: Math.max(n, o - 1),
    nextPage: Math.min(o + 1, c),
    leastVisitedPage: o,
    highestVisitedPage: o
  });
  m(function() {
    e.current.totalPage = c, e.current.startPage = n, e.current.isFirstRender = h, e.current.currentPage = o;
  }, [c, n, h, o]);
  var V = y(o), r = V[0], P = V[1];
  m(function() {
    e.current.isFirstRender || (e.current.leastVisitedPage = r < e.current.leastVisitedPage ? r : e.current.leastVisitedPage, e.current.highestVisitedPage = r > e.current.highestVisitedPage ? r : e.current.highestVisitedPage, e.current.nextPage = Math.min(r + 1, e.current.totalPage), e.current.previousPage = Math.max(e.current.startPage, r - 1), e.current.currentPage = r, u.current.onPageChange == null || u.current.onPageChange(e.current), e.current.lastPage = r);
  }, [r]);
  var b = v(function() {
    P(function(a) {
      return a + 1 > e.current.totalPage ? e.current.startPage : a + 1;
    });
  }, []), C = A(
    b,
    T ? I : null
    // setInterval only when autoNavigate is true. passing null will not schedule a interval.
  ), F = C.setInterval, M = C.clearInterval, j = v(function() {
    P(function(a) {
      var t = a + 1;
      t > e.current.totalPage && (t = g ? e.current.startPage : e.current.totalPage);
      var s = u.current.onNextPage == null ? void 0 : u.current.onNextPage(Object.assign({}, e.current, {
        currentPage: a
      }));
      return s === !1 ? a : t;
    });
  }, [g]), O = v(function() {
    P(function(a) {
      var t = a - 1;
      t < e.current.startPage && (t = g ? e.current.totalPage : e.current.startPage);
      var s = u.current.onPreviousPage == null ? void 0 : u.current.onPreviousPage(Object.assign({}, e.current, {
        currentPage: a
      }));
      return s === !1 ? a : t;
    });
  }, [g]), S = v(function(a) {
    var t = a;
    t > e.current.totalPage ? t = g ? e.current.startPage : e.current.totalPage : t < e.current.startPage && (t = g ? e.current.totalPage : e.current.startPage);
    var s = !0;
    t < e.current.currentPage && (s = u.current.onPreviousPage == null ? void 0 : u.current.onPreviousPage(e.current)), t > e.current.currentPage && (s = u.current.onNextPage == null ? void 0 : u.current.onNextPage(e.current)), s !== !1 && P(t);
  }, [g]), $ = v(function() {
    P(n), e.current.previousPage = n, e.current.leastVisitedPage = n, e.current.highestVisitedPage = n;
  }, [n]);
  return Object.assign({}, e.current, {
    currentPage: r,
    totalPage: c,
    setCurrentPage: P,
    canGoToNextPage: r < c,
    canGoToPreviousPage: r > n,
    goToNextPage: j,
    gotToPreviousPage: O,
    goToPage: S,
    resetToStartPage: $,
    startAutoNavigation: F,
    stopAutoNavigation: M
  });
}
export {
  Q as usePagination
};
